<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <modal
          v-if="showModalsorce"
          @close="
            showModalsorce = false;
            SourceT = Source;
          "
        >
          <h3 slot="header"></h3>
          <div slot="body">
            <div class="md-layout-item md-size-100 ml-15 mt-25">
              <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                <label>سبب الإيقاف</label>
                <md-input v-model="SuspentionNote"></md-input>
              </md-field>
            </div>
          </div>
          <div slot="footer">
            <md-button @click="showModalsorce = false" class="md-danger">الغاء</md-button>
            <md-button style="margin-right: 32px;" @click="suspend" class="md-success">متابعة</md-button>
          </div>
        </modal>

        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">البحث عن المرتبات المحتسبة</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-30 mt-25 ml-15">
                <md-datepicker v-model="MounthDate">
                  <label class="mr-28">شهر المرتب</label>
                </md-datepicker>
              </div>

              <div class="md-layout-item md-size-30 mt-25 ml-15">
                <md-datepicker v-model="PaymentDate">
                  <label class="mr-28">تاريخ الصرف</label>
                </md-datepicker>
              </div>

              <div class="md-layout-item md-size-30 ml-15 mt-25">
                <model-list-select
                  :list="employees"
                  v-model="EmployeeId"
                  option-value="key"
                  option-text="value"
                  placeholder="الموظف"
                ></model-list-select>
              </div>

              <div class="md-layout-item md-size-30 ml-15 mt-25">
                <md-field>
                  <label>تصنيف الفروع</label>
                  <md-select v-model="ClassificationsId">
                    <md-option
                      v-for="dep in departmentClassifications"
                      v-bind:key="dep.id"
                      :value="dep.id"
                    >{{ dep.name }}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-30 ml-15 mt-25">
                <md-field>
                  <label>الإدارة/المكتب</label>
                  <md-select v-model="Administration">
                    <md-option
                      v-for="departments in departments"
                      v-bind:key="departments.id"
                      :value="departments.id"
                    >{{ departments.name }}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-30 ml-15 mt-25">
                <md-field>
                  <label>القسم/المشروع</label>
                  <md-select v-model="Section">
                    <md-option
                      v-for="depa_S in departments_Section"
                      v-bind:key="depa_S.id"
                      :value="depa_S.id"
                    >{{ depa_S.name }}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-30 ml-15 mtb-25">
                <md-field>
                  <label>حالة المرتب</label>

                  <md-select v-model="SalaryStatus">
                    <md-option value="1">في الإحتساب</md-option>
                    <md-option value="2">إعتماد الإحتساب</md-option>
                    <md-option value="3">في الإفراج</md-option>
                    <md-option value="4">إفراج</md-option>
                    <md-option value="5">مغلق</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-30 ml-15 mtb-25">
                <md-field>
                  <label>موقوف</label>
                  <md-select v-model="isSuspended">
                    <md-option value="true">نعم</md-option>
                    <md-option value="false">لا</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-30 ml-15 mtb-25">
                <md-field>
                  <label>عدد النتائج</label>

                  <md-select v-model="PageSize">
                    <md-option value="000">All</md-option>
                    <md-option value="25">25</md-option>
                    <md-option value="50">50</md-option>
                    <md-option value="75">75</md-option>
                    <md-option value="100">100</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-100 mt-25 mtb-25 center-content">
                <md-button @click="Search" class="md-success btn_nanosoft">بحث</md-button>

                <md-button @click="close_month" class="md-danger btn_nanosoft">اغلاق الشهر</md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">اعتماد المرتبات</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 mt-25 mtb-25 center-content">
              <md-button
                v-show="linkingByAccounting"
                @click="calculated"
                class="md-success btn_nanosoft"
              >اعتماد الإحتساب</md-button>

              <md-button
                v-show="linkingByAccounting"
                @click="returncalculated"
                class="md-danger btn_nanosoft"
              >الغاء الإعتماد</md-button>

              <md-button @click="tracking" class="md-danger btn_nanosoft">ايقاف</md-button>

              <md-button @click="release" class="md-success btn_nanosoft">افراج</md-button>
            </div>
          </div>

          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item">
              <md-table-toolbar>
                <md-field>
                  <label for="pages">عدد النتائج</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >{{ item }}</md-option>
                  </md-select>
                </md-field>
              </md-table-toolbar>
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell>
                <div class="md-layout-item md-size-20 center-content">
                  <md-checkbox v-model="item.isActive" @change="add(item)"></md-checkbox>
                </div>
              </md-table-cell>

              <md-table-cell @click.native="handleEdit(item)" md-label="رقم الملاك الوظيفي">
                {{
                item.jobNumber
                }}
              </md-table-cell>

              <md-table-cell @click.native="handleEdit(item)" md-label="الإسم الرباعي">
                {{
                item.employeeName
                }}
              </md-table-cell>

              <md-table-cell @click.native="handleEdit(item)" md-label="الوحدة التنظيمية">
                {{
                item.departmentName
                }}
              </md-table-cell>

              <md-table-cell
                @click.native="handleEdit(item)"
                v-if="item.salaryState == '1'"
                md-label="حالة المرتب"
              >في الإحتساب</md-table-cell>

              <md-table-cell
                @click.native="handleEdit(item)"
                v-if="item.salaryState == '2'"
                md-label="حالة المرتب"
              >إعتماد الإحتساب</md-table-cell>

              <md-table-cell
                @click.native="handleEdit(item)"
                v-if="item.salaryState == '3'"
                md-label="حالة المرتب"
              >في الإفراج</md-table-cell>

              <md-table-cell
                @click.native="handleEdit(item)"
                v-if="item.salaryState == '4'"
                md-label="حالة المرتب"
              >إفراج</md-table-cell>

              <md-table-cell
                @click.native="handleEdit(item)"
                v-if="item.salaryState == '5'"
                md-label="حالة المرتب"
              >مغلق</md-table-cell>

              <md-table-cell @click.native="handleEdit(item)" md-label="المرتب الأساسي">
                {{
                item.basicSalary
                }}
              </md-table-cell>

              <md-table-cell @click.native="handleEdit(item)" md-label="موقوف">
                {{
                item.isSuspended == false ? "لا" : "نعم"
                }}
              </md-table-cell>

              <md-table-cell @click.native="handleEdit(item)" md-label="معدل/غير معدل">
                {{
                item.isModified == false ? "غير معدل" : "معدل"
                }}
              </md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th v-for="item in footerTable" :key="item.name" class="md-table-head">
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import { SlideYDownTransition } from "vue2-transitions";
// import { extend } from "vee-validate";
// import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
import Modal from "../modal.vue";
import state from "../../../../components/service/state";
// extend("required", required);
// extend("numeric", numeric);
// extend("regex", regex);
// extend("confirmed", confirmed);
export default {
  async created() {
    this.init();
  },
  components: {
    Pagination,
    ModelListSelect,
    Modal
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      EmployeeId: "",
      ClassificationsId: "",
      Administration: "",
      Section: "",
      DeparatmentId: "",
      MounthDate: "",
      PaymentDate: null,
      IsTimeSheet: false,
      SuspentionNote: "",
      showModalsorce: false,
      isSuspended: null,
      linkingByAccounting: false,
      SalaryStatus: "",
      tableData: [],
      employees: [],
      departmentClassifications: [],
      departments: [],
      departments_Section: [],
      Selected: [],

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null
    };
  },

  watch: {
    async Administration() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/Departments/${this.Administration}/load`,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );
        (this.Section = ""), (this.departments_Section = result.data.data);
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    }
  },

  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    firstday(d) {
      const date = new Date(d);
      date.setDate(1);
      return date;
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },

    // day(){
    //     this.firstday (this.MounthDate);
    // },
    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        this.tableData = state.ConfirmedSalary;
        let result = await axios.get(`${env.HR()}/api/Salaries`, {
          headers: { Authorization: "Bearer " + token }
        });
        this.employees = result.data.data.employees;
        this.departmentClassifications =
          result.data.data.departmentClassifications;
        this.departments = result.data.data.departments;

        let result_Setting = await axios.get(`${env.HR()}/api/Setting`, {
          headers: { Authorization: "Bearer " + token }
        });
        this.linkingByAccounting = result_Setting.data.data.linkingByAccounting;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },

    async Search() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        // if (!this.EmployeeId && !this.Administration && !this.ClassificationsId  ) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء الإدخال "
        //   );
        // }

        if (this.MounthDate == null) {
          this.MounthDate = "";
        } else {
          this.MounthDate = this.convert(this.firstday(this.MounthDate));
        }

        if (this.Section == "") {
          this.DeparatmentId = this.Administration;
        } else {
          this.DeparatmentId = this.Section;
        }

        let result = await axios.get(
          `${env.HR()}/api/Salaries/filter?EmployeeId=${
            this.EmployeeId
          }&MounthDate=${this.MounthDate}&ClassificationsId=${
            this.ClassificationsId
          }&DeparatmentId=${this.DeparatmentId}&SalaryStatus=${
            this.SalaryStatus
          }&PageSize=${this.PageSize}&IsSuspend=${this.isSuspended}`,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );

        for (let i = 0; i < result.data.data.salaries.results.length; i++) {
          let schema = {
            id: result.data.data.salaries.results[i].id,
            jobNumber: result.data.data.salaries.results[i].jobNumber,
            employeeName: result.data.data.salaries.results[i].employeeName,
            departmentName: result.data.data.salaries.results[i].departmentName,
            salaryState: result.data.data.salaries.results[i].salaryState,
            basicSalary: result.data.data.salaries.results[i].basicSalary,
            isModified: result.data.data.salaries.results[i].isModified,
            isSuspended: result.data.data.salaries.results[i].isSuspended,
            isActive: false
          };
          this.tableData.push(schema);
        }
        state.ConfirmedSalary = this.tableData;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },

    async close_month() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.MounthDate) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال تاريخ الشهر "
          );
        }

        if (!this.PaymentDate) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال تاريخ الصرف "
          );
        }

        let schema = {
          MonthDate: moment(this.MounthDate).format("YYYY/MM/DD hh:mm:ss"),
          PaymentDate: moment(this.PaymentDate).format("YYYY/MM/DD hh:mm:ss")
        };

        let result = await axios.patch(
          `${env.HR()}/api/Salaries/close`,
          schema,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );

        return this.notifyVue("top", "center", "success", result.data.message);
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    async calculated() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.MounthDate) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال تاريخ الشهر "
          );
        }

        let schema = {
          MonthDate: this.MounthDate
        };

        let result = await axios.patch(
          `${env.HR()}/api/Salaries/calculated`,
          schema,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );
        return this.notifyVue(
          "top",
          "center",
          "success",
          "تم اعتماد الإحتساب بنجاح"
        );
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    async returncalculated() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.MounthDate) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال تاريخ الشهر "
          );
        }

        let schema = {
          MonthDate: this.MounthDate
        };

        let result = await axios.patch(
          `${env.HR()}/api/Salaries/returncalculated`,
          schema,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );
        return this.notifyVue("top", "center", "success", "تم إلغاء الإعتماد");
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    async suspend() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let schema = {
          SelectedSalaries: this.Selected,
          SuspentionNote: this.SuspentionNote
        };
        this.showModalsorce = false;

        let result = await axios.patch(
          `${env.HR()}/api/Salaries/suspend`,
          schema,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );

        this.showModalsorce = false;
        return this.notifyVue("top", "center", "success", result.data.message);
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    tracking() {
      this.showModalsorce = true;
      this.SuspentionNote = "";
    },

    async release() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let schema = {
          SelectedSalaries: this.Selected
        };

        let result = await axios.patch(
          `${env.HR()}/api/Salaries/release`,
          schema,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );
        return this.notifyVue("top", "center", "success", result.data.message);
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    add(item) {
      if (item.isActive == true) {
        this.Selected.push(item.id);
      } else {
        for (let i = 0; i < this.Selected.length; i++) {
          if (this.Selected[i] == item.id) {
            this.Selected.splice(i, 1);
          }
        }
      }
    },

    handleEdit(item) {
      this.$router.push("details_salary/" + item.id);
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "تعم",
        cancelButtonText: "لا",
        buttonsStyling: false
      }).then(async result => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/Salaries/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token }
              }
            );
            this.deleteRow(item);
            this.init();
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              error.response.data.message
            );
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  }
};
</script>

<style>
.modal {
  height: 260px !important;
  width: 434px !important;
  z-index: 999;
  background: #ffffff;
  -webkit-box-shadow: 2px 2px 20px 1px;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.btn-close {
  z-index: 999;
  position: absolute;
  top: revert;
  left: 20px;
  right: auto;
  font-size: 24px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: red !important;
  background: transparent;
  display: none;
}
</style>
